import { Api, Auth } from '~/services'


export function fetchInvoices( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_INVOICES'
				})

				Api.get( '/wp/invoices', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_INVOICES',
						invoices: data
					})
				})

			}
		)
	}
}


export function getSubscription(  ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SUBSCRIPTION'
				})

				Api.get( '/wp/subscription', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_SUBSCRIPTION',
						subscription: data,
					})
				})

			}
		)
	}
}


export function buyCredits( credits, stripeToken ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		var data = {
			secure_token: Auth.getToken(),
			method: 'bought',
			action: 'one-off'
		}
		if( stripeToken ) data.stripe_token = stripeToken;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_ADD_CREDITS'
				})

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.post( '/wp/credits/' + credits, data, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_ADD_CREDITS'
					})
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data
					})
				})

			}
		)
	}
}


export function changeSubscription( plan_id, frequency, stripeToken ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		var data = {
			secure_token: Auth.getToken(),
			frequency: frequency
		}
		if( stripeToken ) data.stripe_token = stripeToken;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SUBSCRIPTION'
				})

				Api.post( '/wp/subscription/' + plan_id, data, ( data, error ) => {
					if ( ! data || error ) return;

					dispatch({
						type: 'RECEIVE_SUBSCRIPTION',
						subscription: data.subscription
					})

					dispatch({
						type: 'RECEIVE_SESSION',
						user: data.user
					})

					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})

				})

			}
		)
	}
}


export function finishSubscription( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SUBSCRIPTION'
				})

				Api.delete( '/wp/subscription', {
					secure_token: Auth.getToken(),
				}, ( data, error ) => {
					if ( ! data || error ) return;

					dispatch({
						type: 'RECEIVE_SUBSCRIPTION',
						subscription: data.subscription
					})

					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
				})

			}
		)
	}
}


export function reviveSubscription( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SUBSCRIPTION'
				})

				Api.put( '/wp/subscription/revive', {
					secure_token: Auth.getToken(),
				}, ( data, error ) => {
					if ( ! data || error ) return;

					dispatch({
						type: 'RECEIVE_SUBSCRIPTION',
						subscription: data.subscription
					})

					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
				})

			}
		)
	}
	
}



// WEBPACK FOOTER //
// ./src/js/actions/subscriptions.js